export default function EmailIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8C4 7.46957 4.21071 6.96086 4.58579 6.58579C4.96086 6.21071 5.46957 6 6 6H18C18.5304 6 19.0391 6.21071 19.4142 6.58579C19.7893 6.96086 20 7.46957 20 8V16C20 16.5304 19.7893 17.0391 19.4142 17.4142C19.0391 17.7893 18.5304 18 18 18H6C5.46957 18 4.96086 17.7893 4.58579 17.4142C4.21071 17.0391 4 16.5304 4 16V8ZM7.519 8L12 10.671L16.481 8H7.519ZM18 9.329L12.659 12.753C12.4766 12.9128 12.2424 13.0009 12 13.0009C11.7576 13.0009 11.5234 12.9128 11.341 12.753L6 9.329V16H18V9.329Z"
        fill="#3C3C3C"
      />
    </svg>
  );
}
